import { BCMSStateManagerCRUD, BCMSRecord, useBCMSContext } from "@bcm-dev/bcms-vite";
import Classes, { Account, PositivePayCheckFile } from "model";
import TASPositivePayCreateTemplatePage, { getDefaultData, getDefaultUI } from "components/pages/TASPositivePayCreateTemplatePage";
import CaptureNotShownView from "components/shared/views/CaptureNotShownView";

/**
 * @name CapturePositivePayImportChecksAllColumnsSelected
 * @returns {React.Component}
 * @description A capture in the "Positive Pay - Import Checks - Misc" capture group.
 */
export default function CapturePositivePayImportChecksAllColumnsSelected(props) {
    const context = useBCMSContext();
    BCMSRecord.globalControllerFor(Classes, context);
    const { branding } = context.state;
    const hasBusinessAccounts = Account.hasBusinessAccounts(branding);

    if(!hasBusinessAccounts) {
        const message = Account.businessOnlyBrandingErrorMessage;
        return <CaptureNotShownView message={ message }/>;
    }

    const defaultData = getDefaultData();
    defaultData.selectedColumns = defaultData.selectedColumns.reduce((acc, item) => {
        if(item.id === "0") {
            acc.push({ id: "0", value: { id: "1", value: "Payee", class: "payee", isSelected: true } });
        } else if(item.id === "1") {
            acc.push({ id: "1", value: { id: "2", value: "Amount", class: "amount", isSelected: true } });
        } else if(item.id === "2") {
            acc.push({ id: "2", value: { id: "3", value: "Account Number", class: "account-number", isSelected: true } });
        } else if(item.id === "3") {
            acc.push({ id: "3", value: { id: "4", value: "Item Type Code", class: "item-type-code", isSelected: true } });
        } else if(item.id === "4") {
            acc.push({ id: "4", value: { id: "5", value: "Account Type", class: "account-type", isSelected: true } });
        } else if(item.id === "5") {
            acc.push({ id: "5", value: { id: "6", value: "Reference Number", class: "reference-number", isSelected: true } });
        } else if(item.id === "6") {
            acc.push({ id: "6", value: { id: "7", value: "Check Number (Required)", class: "check-number", isSelected: true } });
        } else if(item.id === "7") {
            acc.push({ id: "7", value: { id: "8", value: "Issued Date", class: "issued-date", isSelected: true } });
        }
        return acc;
    }, []);

    defaultData.mapColumns = defaultData.mapColumns.reduce((acc, item) => {
        item.isSelected = true;
        acc.push(item);
        return acc;
    }, []);

    const data = BCMSStateManagerCRUD.init(defaultData)
    .update([ "checkTemplate", "positivePayCheckFile" ], PositivePayCheckFile.initByID("0"))
    .update([ "checkTemplate", "name" ], "Sample")
    .submit();
    
    const ui = BCMSStateManagerCRUD.init( getDefaultUI(data.checkTemplate))
    .update([ "checkTemplate", "showFilePreview", "isActive" ], true)
    .submit();

    return <TASPositivePayCreateTemplatePage data={ data } ui={ ui } />;
}